/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Criteria } from './Criteria';
import {
    CriteriaFromJSON,
    CriteriaFromJSONTyped,
    CriteriaToJSON,
} from './Criteria';

/**
 * 
 * @export
 * @interface FindAllCriteria200Response
 */
export interface FindAllCriteria200Response {
    /**
     * 
     * @type {Array<Criteria>}
     * @memberof FindAllCriteria200Response
     */
    data?: Array<Criteria>;
}

/**
 * Check if a given object implements the FindAllCriteria200Response interface.
 */
export function instanceOfFindAllCriteria200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllCriteria200ResponseFromJSON(json: any): FindAllCriteria200Response {
    return FindAllCriteria200ResponseFromJSONTyped(json, false);
}

export function FindAllCriteria200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCriteria200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(CriteriaFromJSON)),
    };
}

export function FindAllCriteria200ResponseToJSON(value?: FindAllCriteria200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(CriteriaToJSON)),
    };
}

